// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__-zBtq","inputWrap":"styles_inputWrap__2r0MW","input":"styles_input__3y_vw"};